// extracted by mini-css-extract-plugin
export default {"AllNotes":"PinnedList_AllNotes__MCSgl","otherListWrapper":"PinnedList_otherListWrapper__h-BxS","noteType":"PinnedList_noteType__6+xv7"};